import Layout from '@/layout/index.vue';
export default [
  {
    // 商品
    path: '/orderManage',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'orderDetails',
        component: () => import('@/views/orderManage/orderDetails.vue'),
        name: 'OrderDetails',
        meta: { title: '订单详情', icon: '', noCache: true },
      },
      {
        path: 'refundDetails',
        component: () => import('@/views/orderManage/refundDetails.vue'),
        name: 'RefundDetails',
        meta: { title: '退款详情', icon: '', noCache: true },
      },
    ],
  },
];
